export const NAVBAR_SIZE = '4.3rem';
export const SIDEMENU_SIZE = '176px';
export const SIDEMENU_CLOSED_SIZE = '36px';
export const HEADER_SIZE = '56px';
export const FOOTER_SIZE = '60px';
